import { Autocomplete, Checkbox, FormControl, FormControlLabel, Stack, Button, FormGroup, Grid, MenuItem, Select, TextField, Box, Typography, OutlinedInput } from '@mui/material'
import React, { useState } from 'react'
import SearchIcon from '@mui/icons-material/Search';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import InputAdornment from '@mui/material/InputAdornment';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

export default function BrowseCoachSidebar() {
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedLocation, setSelectedLocation] = useState(null);

  const [serviceNames, setServiceNames] = useState({
    serviceName1: false,
    serviceName2: false,
    serviceName3: false,
    showAll: false,
  });

  const [selectedExperiance, setSelectedExperiance] = useState({
    expeiance1: false,
    expeiance2: false,
    expeiance3: false,
    showAll: false,
  });

  const [selectedIndustry, setSelectedIndustry] = useState({
    industry1: false,
    industry2: false,
    industry3: false,
    showAll: false,
  });

  const [selectedCostRange, setSelectedCostRange] = useState({
    costRange1: false,
    costRange2: false,
    costRange3: false,
    showAll: false,
  });

  const [selectedCoachingExperiance, setSelectedCoachingExperiance] = useState({
    coachingExperiance1: false,
    coachingExperiance2: false,
    coachingExperiance3: false,
    showAll: false,
  });

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setServiceNames((prevCheckedItems) => ({
      ...prevCheckedItems,
      [name]: checked,
    }));
  };

  const handleExperianceChange = (event) => {
    const { name, checked } = event.target;
    setServiceNames((prevCheckedItems) => ({
      ...prevCheckedItems,
      [name]: checked,
    }));
  };

  const handleIndustryChange = (event) => {
    const { name, checked } = event.target;
    setServiceNames((prevCheckedItems) => ({
      ...prevCheckedItems,
      [name]: checked,
    }));
  };

  const handleCostRangeChange = (event) => {
    const { name, checked } = event.target;
    setServiceNames((prevCheckedItems) => ({
      ...prevCheckedItems,
      [name]: checked,
    }));
  };

  const handleCoachingExperianceChange = (event) => {
    const { name, checked } = event.target;
    setServiceNames((prevCheckedItems) => ({
      ...prevCheckedItems,
      [name]: checked,
    }));
  };

  const handleViewAllClick = () => {
    setServiceNames((prevCheckedItems) => ({
      ...prevCheckedItems,
      showAll: !serviceNames.showAll,
    }));
  };

  const handleExperianceViewAllClick = () => {
    setSelectedExperiance((prevCheckedItems) => ({
      ...prevCheckedItems,
      showAll: !serviceNames.showAll,
    }));
  };

  const handleIndustryViewAllClick = () => {
    setSelectedExperiance((prevCheckedItems) => ({
      ...prevCheckedItems,
      showAll: !serviceNames.showAll,
    }));
  };

  const handleCostRangeViewAllClick = () => {
    setSelectedExperiance((prevCheckedItems) => ({
      ...prevCheckedItems,
      showAll: !serviceNames.showAll,
    }));
  };

  const handleCoachingExperianceViewAllClick = () => {
    setSelectedExperiance((prevCheckedItems) => ({
      ...prevCheckedItems,
      showAll: !serviceNames.showAll,
    }));
  };

  const handleChange = (event) => {
    setSelectedCategory(event.target.value);
  };

  return (
    <Grid container>
      <Grid item md={12} px={3}>
        <Stack
          my={2}
          sx={{
            background: 'linear-gradient(45deg, #F2F4FB 30%, #C8D8F1 90%)', // Specify your gradient colors
            borderRadius: '10px',
            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
            padding: '1rem',
          }}
        >
          <Typography variant='body1' className='text1Bold' my={1}>Coache Name</Typography>
          <FormControl>
            <OutlinedInput
              endAdornment={<SearchIcon />}
              inputProps={{
                placeholder:'Enter Coach Name',
                style: {...{padding:'10px 14px'}}
              }}
              sx={{bgcolor:'#FFF', border:'none', borderRadius:'11px'}}
            />
          </FormControl>
          <Typography variant='body1' className='text1Bold' my={1}>Category</Typography>
          <select
            className='profile-skills-box'
            value={selectedCategory}
            onChange={handleChange}

            displayEmpty
            fullWidth
            variant="outlined"
            sx={{ background: 'white', border: 'none' }} // Updated style
          >
            <option value="" disabled>
              All Category
            </option>
            <option value="category1">Category 1</option>
            <option value="category2">Category 2</option>
            <option value="category3">Category 3</option>
          </select>

          <Typography variant='body1' className='text1Bold' my={1}>Service Name</Typography>
          <FormControl component="fieldset" sx={{ border: 'none' }}>
            <FormGroup column>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={serviceNames.checkbox1}
                    onChange={handleCheckboxChange}
                    name="Service 1"
                  />
                }
                label="Service 1"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={serviceNames.checkbox2}
                    onChange={handleCheckboxChange}
                    name="Service 2"
                  />
                }
                label="Service 2"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={serviceNames.checkbox3}
                    onChange={handleCheckboxChange}
                    name="Service 3"
                  />
                }
                label="Service 3"
              />
            </FormGroup>
          </FormControl>

          {serviceNames.showAll && (
            <FormControl component="fieldset" sx={{ border: 'none' }}>
              <FormGroup column>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={serviceNames.checkbox4}
                      onChange={handleCheckboxChange}
                      name="Service 4"
                    />
                  }
                  label="Service 4"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={serviceNames.checkbox5}
                      onChange={handleCheckboxChange}
                      name="Service 5"
                    />
                  }
                  label="Service 5"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={serviceNames.checkbox6}
                      onChange={handleCheckboxChange}
                      name="Service 6"
                    />
                  }
                  label="Service 6"
                />
              </FormGroup>
            </FormControl>
          )}
          <Button
            sx={{
              backgroundColor: 'transparent',
              border: 'none',
              boxShadow: 'none', color: '#2544EE',
              width: 'fit-content',
              '&:hover': {
                backgroundColor: 'transparent',
                border: 'none',
                boxShadow: 'none',
                color: '#FF0000', // Example: Change color on hover
              },
            }}
            variant="contained" onClick={handleViewAllClick}>
            {
              serviceNames.showAll
              ?
              "View All"
              :
              "Show Less"
            }
          </Button>

          <Typography variant='body1' className='text1Bold' my={1}>Experience</Typography>
          <FormControl component="fieldset" sx={{ border: 'none' }}>
            <FormGroup column>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={serviceNames.checkbox1}
                    onChange={handleCheckboxChange}
                    name="checkbox1"
                  />
                }
                label="Checkbox 1"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={serviceNames.checkbox2}
                    onChange={handleCheckboxChange}
                    name="checkbox2"
                  />
                }
                label="Checkbox 2"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={serviceNames.checkbox3}
                    onChange={handleCheckboxChange}
                    name="checkbox3"
                  />
                }
                label="Checkbox 3"
              />
            </FormGroup>
          </FormControl>

          {serviceNames.showAll && (
            <FormControl component="fieldset" sx={{ border: 'none' }}>
              <FormGroup column>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={serviceNames.checkbox4}
                      onChange={handleCheckboxChange}
                      name="checkbox4"
                    />
                  }
                  label="Checkbox 4"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={serviceNames.checkbox5}
                      onChange={handleCheckboxChange}
                      name="checkbox5"
                    />
                  }
                  label="Checkbox 5"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={serviceNames.checkbox6}
                      onChange={handleCheckboxChange}
                      name="checkbox6"
                    />
                  }
                  label="Checkbox 6"
                />
              </FormGroup>
            </FormControl>
          )}
          <Button
            sx={{
              backgroundColor: 'transparent',
              border: 'none',
              boxShadow: 'none', color: '#2544EE',
              width: 'fit-content',
              '&:hover': {
                backgroundColor: 'transparent',
                border: 'none',
                boxShadow: 'none',
                color: '#FF0000', // Example: Change color on hover
              },
            }}
            variant="contained" onClick={handleViewAllClick}>
            View All
          </Button>

          <Typography variant='body1' className='text1Bold' my={1}>Industry</Typography>
          <FormControl component="fieldset" sx={{ border: 'none' }}>
            <FormGroup column>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={serviceNames.checkbox1}
                    onChange={handleCheckboxChange}
                    name="checkbox1"
                  />
                }
                label="Checkbox 1"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={serviceNames.checkbox2}
                    onChange={handleCheckboxChange}
                    name="checkbox2"
                  />
                }
                label="Checkbox 2"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={serviceNames.checkbox3}
                    onChange={handleCheckboxChange}
                    name="checkbox3"
                  />
                }
                label="Checkbox 3"
              />
            </FormGroup>
          </FormControl>

          {serviceNames.showAll && (
            <FormControl component="fieldset" sx={{ border: 'none' }}>
              <FormGroup column>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={serviceNames.checkbox4}
                      onChange={handleCheckboxChange}
                      name="checkbox4"
                    />
                  }
                  label="Checkbox 4"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={serviceNames.checkbox5}
                      onChange={handleCheckboxChange}
                      name="checkbox5"
                    />
                  }
                  label="Checkbox 5"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={serviceNames.checkbox6}
                      onChange={handleCheckboxChange}
                      name="checkbox6"
                    />
                  }
                  label="Checkbox 6"
                />
              </FormGroup>
            </FormControl>
          )}
          <Button
            sx={{
              backgroundColor: 'transparent',
              border: 'none',
              boxShadow: 'none', color: '#2544EE',
              width: 'fit-content',
              '&:hover': {
                backgroundColor: 'transparent',
                border: 'none',
                boxShadow: 'none',
                color: '#FF0000', // Example: Change color on hover
              },
            }}
            variant="contained" onClick={handleViewAllClick}>
            View All
          </Button>

          <Typography variant='body1' className='text1Bold' my={1}>Cost Range</Typography>
          <FormControl component="fieldset" sx={{ border: 'none' }}>
            <FormGroup column>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={serviceNames.checkbox1}
                    onChange={handleCheckboxChange}
                    name="checkbox1"
                  />
                }
                label="Checkbox 1"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={serviceNames.checkbox2}
                    onChange={handleCheckboxChange}
                    name="checkbox2"
                  />
                }
                label="Checkbox 2"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={serviceNames.checkbox3}
                    onChange={handleCheckboxChange}
                    name="checkbox3"
                  />
                }
                label="Checkbox 3"
              />
            </FormGroup>
          </FormControl>

          {serviceNames.showAll && (
            <FormControl component="fieldset" sx={{ border: 'none' }}>
              <FormGroup column>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={serviceNames.checkbox4}
                      onChange={handleCheckboxChange}
                      name="checkbox4"
                    />
                  }
                  label="Checkbox 4"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={serviceNames.checkbox5}
                      onChange={handleCheckboxChange}
                      name="checkbox5"
                    />
                  }
                  label="Checkbox 5"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={serviceNames.checkbox6}
                      onChange={handleCheckboxChange}
                      name="checkbox6"
                    />
                  }
                  label="Checkbox 6"
                />
              </FormGroup>
            </FormControl>
          )}
          <Button
            sx={{
              backgroundColor: 'transparent',
              border: 'none',
              boxShadow: 'none', color: '#2544EE',
              width: 'fit-content',
              '&:hover': {
                backgroundColor: 'transparent',
                border: 'none',
                boxShadow: 'none',
                color: '#FF0000', // Example: Change color on hover
              },
            }}
            variant="contained" onClick={handleViewAllClick}>
            View All
          </Button>
          <Typography variant='body1' className='text1Bold' my={1}>Coaching Experience</Typography>
          <FormControl component="fieldset" sx={{ border: 'none' }}>
            <FormGroup column>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={serviceNames.checkbox1}
                    onChange={handleCheckboxChange}
                    name="checkbox1"
                  />
                }
                label="Checkbox 1"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={serviceNames.checkbox2}
                    onChange={handleCheckboxChange}
                    name="checkbox2"
                  />
                }
                label="Checkbox 2"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={serviceNames.checkbox3}
                    onChange={handleCheckboxChange}
                    name="checkbox3"
                  />
                }
                label="Checkbox 3"
              />
            </FormGroup>
          </FormControl>

          {serviceNames.showAll && (
            <FormControl component="fieldset" sx={{ border: 'none' }}>
              <FormGroup column>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={serviceNames.checkbox4}
                      onChange={handleCheckboxChange}
                      name="checkbox4"
                    />
                  }
                  label="Checkbox 4"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={serviceNames.checkbox5}
                      onChange={handleCheckboxChange}
                      name="checkbox5"
                    />
                  }
                  label="Checkbox 5"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={serviceNames.checkbox6}
                      onChange={handleCheckboxChange}
                      name="checkbox6"
                    />
                  }
                  label="Checkbox 6"
                />
              </FormGroup>
            </FormControl>
          )}
          <Button
            sx={{
              backgroundColor: 'transparent',
              border: 'none',
              boxShadow: 'none', color: '#2544EE',
              width: 'fit-content',
              '&:hover': {
                backgroundColor: 'transparent',
                border: 'none',
                boxShadow: 'none',
                color: '#FF0000', // Example: Change color on hover
              },
            }}
            variant="contained" onClick={handleViewAllClick}>
            View All
          </Button>
        </Stack>

      </Grid>
    </Grid>
  )
}
